<template>
  <div style="height: 100%">
    <Header title="이전 상담 내역" :isBack="false" :isHistory="false"></Header>

    <div class="historyCon">
      <div class="listBox" v-show="roomList.length > 0">
        <div class="scroll">
          <div class="deleteBtn" v-if="!isLoginId">
            <a @click="deleteHistory">
              <i class="UXicon-delete_outlined"></i>
              상담내역 전체 삭제
            </a>
          </div>

          <ul>
            <li v-for="(item, idx) in roomList" :key="idx" @click="chatroomDetail(item)">
              <div class="userImage">
                <p class="pic">
                  <img v-if="channelType === 'chat'" src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_webchat_v2.png" />

                  <img v-else src="https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/icon_chatbot_v2.png" />
                </p>
              </div>

              <dl>
                <dt>
                  <p>{{ headerStyle.toolbarAgentName }}</p>
                </dt>

                <dd>
                  <span>{{ printCreateMessageDate(item.lastMessageDate) }}</span>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
      </div>

      <div class="notData" v-show="roomList.length === 0">
        <p>
          상담사와 상담한 내역이 없습니다.
          <br />
          상담하신 내역은 기기 별로 확인하실 수 있습니다.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import helpers from '@/util/helpers';
import Header from '@/components/Header';
import { v1 as uuidv1 } from 'uuid';

export default {
  name: 'History',
  components: {
    Header
  },
  computed: {
    ...mapGetters(['chatRoomData', 'historyData'])
  },
  data() {
    return {
      headerStyle: {},
      brandKey: '',
      userKey: '',
      currentlyChatRoom: window.sessionStorage.getItem('CURRENTLY_CHATROOM') ? JSON.parse(window.sessionStorage.getItem('CURRENTLY_CHATROOM')) : {},
      roomList: [],
      currentPage: 1,
      totalPages: 1,
      scrollInit: true,
      elm: null,
      isProgress: false,
      isLoginId: false,
      channelType: ''
    };
  },
  mounted() {
    if (this.$route.query.brandKey && this.$route.query.channelType) {
      this.brandKey = this.$route.query.brandKey;
      this.channelType = this.$route.query.channelType;
      if (this.$route.query.loginId) {
        this.userKey = this.$route.query.loginId;
        this.isLoginId = true;
      } else {
        this.userKey = window.localStorage.getItem(process.env.VUE_APP_UUID_KEY) || uuidv1();
      }
      this.headerStyle = this.chatRoomData.headerStyle;
      // if (this.historyData.roomList.length > 0) {
      //     this.roomList = this.historyData.roomList
      //     this.currentPage = this.historyData.currentPage
      //     this.totalPages = this.historyData.totalPages
      // }
      this.getChatroomList();
      this.elm = document.querySelector('.scroll');
      this.elm.addEventListener('scroll', this.scrollListener, false);
    } else {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        message: '<dl class="txt"><dd>잘못된 접근 입니다.</dd></dl>'
      });
    }
  },
  methods: {
    ...mapMutations(['clearChatRoomData', 'setHistoryData', 'clearHistoryData']),
    listClear() {
      window.sessionStorage.removeItem('SCENARIO_CHECK_DATA');
      window.sessionStorage.removeItem('CURRENTLY_CHATROOM');

      this.senderUid = window.localStorage.getItem(process.env.VUE_APP_UUID_KEY);
      this.currentlyChatRoom = {};
      this.currentPage = 1;
      this.totalPages = 1;
      this.clearHistoryData();
      this.clearChatRoomData();
      this.roomList = [];
      window.$mitt.emit('socket-connection-success');
    },
    printCreateMessageDate(datetimeString) {
      return helpers.printTimeStampMessageFromDate(datetimeString);
    },
    deleteHistory() {
      this.$mitt.emit('DialogPopup', {
        useDialog: true,
        message:
          '<dl class="txt"><dt>상담 내역을 모두<br />삭제하시겠습니까?</dt><dd>현재 사용 중인 기기에서만 삭제되고,<br />진행 중인 상담은 상담이 종료됩니다.</dd></dl>',
        getBtnCount: 2,
        getButtonEvent: () => {
          this.$http({
            method: 'POST',
            url: '/api/external/webchat/closeChatRoom',
            data: {
              chatRoomId: this.chatRoomData.chatRoomId
            }
          }).then((res) => {
            if (res.data.code !== 0) {
              this.$mitt.emit('DialogPopup', {
                useDialog: true,
                message: '<dl class="txt"><dd>' + res.data.message + '</dd></dl>'
              });
            } else {
              this.listClear();
            }
          });
        }
      });
    },
    scrollListener() {
      if (this.scrollInit && this.elm.scrollTop + this.elm.clientHeight + 400 >= this.elm.scrollHeight && this.currentPage < this.totalPages) {
        this.currentPage = this.currentPage + 1;
        this.getChatroomList();
      }
    },
    chatroomDetail(item) {
      this.$router.push({
        path: '/history/detail',
        query: { chatRoomId: item.chatRoomId, agentName: item.agentName }
      });
    },
    getChatroomList() {
      this.scrollInit = false;
      this.$http({
        method: 'GET',
        url: `/api/external/webchat/history`,
        params: {
          statuses: this.channelType === 'chat' ? 'SUMMARY_WAITING,COMPLETED' : 'SCENARIO_END', // 시나리오: SCENARIO_START, SCENARIO_END 웹챗: SUMMARY_WAITING,COMPLETED
          brandKeyEncrypt: this.brandKey,
          userKey: this.userKey,
          page: this.currentPage,
          size: 10,
          ascending: false
        }
      }).then((result) => {
        const res = result.data;
        if (res.code !== 0) {
          this.roomList = [];
          this.$mitt.emit('DialogPopup', {
            useDialog: true,
            message: '<dl class="txt"><dd>' + res.message + '</dd></dl>'
          });
        } else {
          this.currentPage = res.currentPage;
          this.totalPages = res.totalPages;
          this.roomList = this.roomList.concat(res.data);
          if (this.currentPage === 1 && this.roomList.length > 0) {
            this.isProgress = this.roomList[0].chatRoomId === this.currentlyChatRoom.id;
          }
          this.setHistoryData({
            roomList: this.roomList,
            currentPage: this.currentPage,
            totalPages: this.totalPages,
            isProgress: this.isProgress
          });
        }
        this.scrollInit = true;
        setTimeout(() => {
          this.scrollListener();
        });
      });
    }
  }
};
</script>
